import { Box, IconButton } from '@mui/material';
import NextIcon from '@mui/icons-material/ArrowForwardIos';
import PrevIcon from '@mui/icons-material/ArrowBackIos';
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/horizontal.css';
import DownloadIcon from '@mui/icons-material/Download';
import { useTranslation } from 'react-i18next';

function HelpPage() {
    // const isOpen = useRecoilValue(bannerOpenState)
    const {t} = useTranslation();

    const helpImages = [
        {
            title: 'Slide 1',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA1.JPG',
        },
        {
            title: 'Slide 2',
            headerText: 'Header Text Two',
            imageUrl: '/help/DIAPOSITIVA2.JPG',
        },
        {
            title: 'Slide 3',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA3.JPG',
        },
        {
            title: 'Slide 4',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA4.JPG',
        },
        {
            title: 'Slide 5',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA5.JPG',
        },
        {
            title: 'Slide 6',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA6.JPG',
        },
        {
            title: 'Slide 7',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA7.JPG',
        },
        {
            title: 'Slide 8',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA8.JPG',
        },
        {
            title: 'Slide 9',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA9.JPG',
        },
        {
            title: 'Slide 10',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA10.JPG',
        },
        {
            title: 'Slide 11',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA11.JPG',
        },
        {
            title: 'Slide 12',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA12.JPG',
        },
        {
            title: 'Slide 13',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA13.JPG',
        },
        {
            title: 'Slide 14',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA14.JPG',
        },
        {
            title: 'Slide 15',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA15.JPG',
        },
        {
            title: 'Slide 16',
            headerText: null,
            imageUrl: '/help/DIAPOSITIVA16.JPG',
        },
    ]
      
    const NextButton = () => {
        return (
          <IconButton size="large">
            <NextIcon sx={{color: (theme) => theme.palette.primary.main }} />
          </IconButton>
        )
    }
    
    const PrevButton = () => {
        return (
          <IconButton size="large">
            <PrevIcon sx={{color: (theme) => theme.palette.primary.main }} />
          </IconButton>
        )
    }

    const downloadHelp = (e: React.MouseEvent<HTMLButtonElement>) => {

    }
    // width: isOpen ? '93%' : '100%', width={!isOpen ? '80%' : '100%'} 
    // display: 'flex', alignItems: 'center', justifyContent: 'center'
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, alignItems: 'center', mt: 1}}>
                <Slider className="slider previousButton nextButton slider-height" infinite={true} nextButton={<NextButton />} previousButton={<PrevButton />} >
                {helpImages.map((carousel, index) => 
                    <Box key={index} sx={{display: 'flex', justifyContent: 'center'}}>
                        <img src={carousel.imageUrl}></img>
                    </Box>
                )}
                </Slider>
                <Box sx={{pt: 2}}>
                    <IconButton href='/help/mySixtema.pdf' target="_blank" sx={{ width: 22, height: 22, color: (theme) => theme.palette.primary.main }} 
                        title={t('Download manuale')}>
                        <DownloadIcon fontSize='small' />
                    </IconButton>
                    {/* <a href='/help/mySixtema.pdf' target="_blank">Download manuale utente</a> */}
                </Box>
            </Box>
        </>
    )
}

export default HelpPage;